import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import "./index.scss";
import { useAnimateOpening, useSlideLefOpening } from "../../betbar/dropdown";
import { AnimatePresence, motion } from "framer-motion";
import useOrientation from "../../hook/Orientation";
import { useAppDispatch, useAppSelector } from "../../../store/hook";
import { formatCurrency } from "../../../tool/money";
import { Player } from "../../user/auth/type";
import { getPlayer } from "../../user/auth/reducer";
import Game from "../../game/index";
import HistoryIcon from "./../icon-title.webp";
import Up from "./../eye.webp";
import Expand from "./../expand.webp";

const Table = ({
  handleOpen,
  active,
  containerRef,
  motionVariant,
  opening,
  handleClose,
}: ReturnType<typeof useSlideLefOpening>) => {
  const orientation = useOrientation();
  const modes = {
    simple: TableSimple,
    full: TableFull,
    "-": TableFull,
  };
  const modeSelection = 
  // useMemo(
    // () =>{

    //   return 
       orientation == "landscape"
        ? active
          ? "full"
          : "simple"
        : active
        ? "full"
        : "-";
    // }
    //
  //   ,[orientation, active]
  // );
  const ActiveMode = useMemo(
    () => () => modes[modeSelection](),
    [modeSelection]
  );

  const [portraitShow, setPortraitShow] = useState(true);

  if (orientation == "landscape")
    return (
      <motion.div
      // @ts-ignore
      ref={containerRef}
        initial={modeSelection}
        animate={modeSelection}
        variants={motionVariant}
        className={"table-container ".concat(
          orientation == "landscape" ? (active ? "full" : "simple") : "full"
        )}
        // style={{overflow: opening?"hidden":"visible"}}
      >
        <img
          onClick={() => handleOpen()}
          onContextMenu={(e) => e.preventDefault()}
          draggable="false"
          className="expand-icon"
          alt=""
          src={Expand}
        />

        <div className="table-title">
          <div className="title">
            <img
              onContextMenu={(e) => e.preventDefault()}
              draggable="false"
              className="title-bet-icon"
              alt=""
              src={HistoryIcon}
            />
            History of transaction
          </div>
          {/* <img
      title={t("history.table.close")!}
      className="close"
      alt=""
      src={Close}
      onClick={() => handleOpen()}
    /> */}
        </div>
        <div className="table-bg">
          <ActiveMode />
        </div>
      </motion.div>
    );
  else
    return (
      <motion.div
        initial={modeSelection}
        animate={modeSelection}
        variants={{
          ...motionVariant,
          full: {
            // x:"0",
            ...motionVariant.full,
            // height: "0",
            width: "63.5rem",
            marginRight: 0,
          },
        }}
        // @ts-ignore
        ref={containerRef}
        className={"table-container ".concat(
          orientation == "landscape"
            ? active
              ? "full"
              : "simple"
            : active
            ? "full"
            : "-"
        )}
        // style={{overflow: opening?"hidden":"visible"}}
      >
        <img
          onClick={() => {
            handleOpen();
          }}
          onContextMenu={(e) => e.preventDefault()}
          draggable="false"
          className="expand-icon"
          alt=""
          src={Expand}
        />
        <div className="table-title">
          <div className="title">
            <img
              onContextMenu={(e) => e.preventDefault()}
              draggable="false"
              className="title-bet-icon"
              alt=""
              src={HistoryIcon}
            />
            History of transaction
          </div>
        </div>
        <div className="table-bg">
          <ActiveMode />
        </div>
      </motion.div>
    );
};

const TableSimple = () => {
  const dispatch = useAppDispatch();
  const history = useAppSelector((state) => state.history.data);

  const { t, i18n } = useTranslation();
  const orientation = useOrientation();
  const player = useAppSelector(getPlayer) as Player;
  const { player_balance, player_name, player_currency } = player;
  const handleFormatCurrency = (amount: number): string =>
    formatCurrency(amount, player_currency, language);
  const language = i18n.language;

  const animateFade = useAnimateOpening("block", false);

  useEffect(() => {
    animateFade.handleOpen();
    return () => {
      animateFade.handleClose(() => {});
    };
  }, []);

  return (
    <motion.div
      initial="close"
      animate={animateFade.active ? "open" : "close"}
      variants={{...animateFade.motionVariant, open:{
        ...animateFade.motionVariant.open,
        transition:{
          duration: orientation == "landscape" ? animateFade.motionVariant.open.transition.duration : 0,
        }

      }}}
      // @ts-ignore
      ref={animateFade.containerRef}
      className="table table-simple"
    >
      <div className="table-head">
        {/* <img onContextMenu={(e)=>e.preventDefault()} draggable="false" className="head-bg" alt="" src={BGHead} /> */}
        <div className="table-head-scroll">
          <div className="head-list">
            {/* <div className="list-item td-date">{t("history.table.date")}</div>
          <div className="list-item td-mines">{t("history.table.mines")}</div> */}
            <div className="list-item td-period" style={{ width: "6%" }}>
              {t("history.table.period")}
            </div>
            <div className="list-item td-totalbet" style={{ width: "20%" }}>
              {t("history.table.totalbet")}
            </div>
            <div className="list-item td-payout">
              {t("history.table.payout")}
            </div>
            {/* <div className="list-item td-icon">
            {t("history.table.detail")}
          </div> */}
          </div>
        </div>
      </div>
      <div className="table-body">
        <table>
          <tbody>
            {/* <AnimatePresence mode={"popLayout"}> */}

            {history.map((items, idx) => {
              const grouped: any =
                // {[i: typeof items.result[number]["prize"]]: typeof items.result}
                {};
              return (
                <Fragment
                key={"history-table-simple-".concat(orientation).concat(
                  items.round_id.toString()
                    // .concat("first")
                    // .concat(idx.toString())
                  )}
                >
                  <tr>
                    {/* <td align="center" className={"td-date"}>
                    {items.created_date}
                  </td>
                  <td align="center" className={"td-mines"}>
                    {items.data.detail_bet.mines}
                  </td> */}
                    <td align="center" className={"td-period"}>
                      {items.round_id}
                    </td>
                    <td align="center" className={"td-totalbet"}>
                      {handleFormatCurrency(items.data.detail_bet.amount)}
                    </td>
                    <td align="center" className={"td-payout"}>
                      {handleFormatCurrency(items.data.total_win)}
                    </td>
                    {/* <td
                    align="center"
                    className={"td-icon"}
                    onClick={() => {
                      animate.handleClose(() => { });
                      animate.open(animate.active === idx ? -1 : idx);
                    }}
                  >
                    {animate.active === idx ? <img onContextMenu={(e)=>e.preventDefault()} draggable="false" className="" alt="" src={Up} style={{  }} /> : <img onContextMenu={(e)=>e.preventDefault()} draggable="false" className="" alt="" src={Up} style={{ transform: 'rotate(90deg)' }} />}




                  </td> */}
                  </tr>
                  <tr
                    style={{ borderTop: "2px solid rgba(255, 255, 255, 0.1)" }}
                  ></tr>
                </Fragment>
              );
            })}
            {/* </AnimatePresence> */}
          </tbody>
        </table>
      </div>
      {/* <div className="slider-y">
      <form className="rangeSlider">
        <input
          className="scroll-range"
          id="scroll-range-y"
          type="range"
          defaultValue={"0"}
        />
      </form>
    </div>
    <div className="slider-x">
      <form className="rangeSlider">
        <input
          className="scroll-range"
          id="scroll-range-x"
          type="range"
          defaultValue={"0"}
        />
      </form>
    </div> */}
    </motion.div>
  );
};

const TableFull = () => {
  const dispatch = useAppDispatch();
  const history = useAppSelector((state) => state.history.data);

  const { t, i18n } = useTranslation();
  const orientation = useOrientation();
  const player = useAppSelector(getPlayer) as Player;
  const { player_balance, player_name, player_currency } = player;
  const handleFormatCurrency = (amount: number): string =>
    formatCurrency(amount, player_currency, language);
  const language = i18n.language;

  const animate = useAnimateOpening("flex");
  const animateFade = useAnimateOpening("block", false);

  useEffect(() => {
    orientation == "landscape" && animateFade.handleOpen();
    return () => {
      orientation == "landscape" && animateFade.handleClose(() => {});
    };
  }, [orientation]);

  return (
    <motion.div
      initial={orientation == "landscape" ?"close": "open"}
      animate={orientation == "landscape" ? animateFade.active ? "open" : "close" : "open"}
      variants={{
        ...animateFade.motionVariant,
        open: {
          ...animateFade.motionVariant.open,
          transition: {
            ...animateFade.motionVariant.open.transition,
            delay: orientation == "portrait" ? 0 : 0.5,
          },
        },
        close: {
          ...animateFade.motionVariant.close,
          transition: {
            ...animateFade.motionVariant.open.transition,
            delay: orientation == "portrait" ? 3 : 0,
          },
        },
      }}
      // @ts-ignore
      ref={animateFade.containerRef}
      className="table table-full"
    >
      <div className="table-head">
        {/* <img onContextMenu={(e)=>e.preventDefault()} draggable="false" className="head-bg" alt="" src={BGHead} /> */}
        <div className="table-head-scroll">
          <div className="head-list">
            <div className="list-item td-date" style={{ width: "19%" }}>
              {t("history.table.date")}
            </div>
            <div className="list-item td-period">
              {t("history.table.period")}
            </div>
            <div className="list-item td-mines" style={{ width: "20%" }}>
              {t("history.table.difficulty")}
            </div>
            <div className="list-item td-totalbet" style={{ width: "20%" }}>
              {t("history.table.totalbet")}
            </div>
            <div className="list-item td-payout" style={{ width: "20%" }}>
              {t("history.table.payout")}
            </div>
            <div className="list-item td-icon" style={{ width: "10%" }}>
              {t("history.table.detail")}
            </div>
          </div>
        </div>
      </div>
      <div className="table-body">
        <table>
          <tbody>
            {/* <AnimatePresence mode={"popLayout"}> */}

            {history.map((items, idx) => {
              const grouped: any =
                // {[i: typeof items.result[number]["prize"]]: typeof items.result}
                {};
              return (
                <Fragment
                  key={"history-table-full-".concat(orientation).concat(
                    items.round_id
                      .toString()
                      .concat("expand")
                      .concat(idx.toString())
                  )}
                >
                  <tr>
                    <td align="center" className={"td-date"}>
                      {document.querySelector(".safari")
                        ? items.created_date
                        : (() => {
                            const originalDate = new Date(items.created_date);

                            const year = originalDate
                              .getFullYear()
                              .toString()
                              .slice(-2);
                            const month = (
                              "0" +
                              (originalDate.getMonth() + 1)
                            ).slice(-2);
                            const day = ("0" + originalDate.getDate()).slice(
                              -2
                            );
                            const hour = ("0" + originalDate.getHours()).slice(
                              -2
                            );
                            const minute = "00";

                            return `${day}/${month}/${year} ${hour}.${minute}`;
                          })()}
                    </td>
                    <td align="center" className={"td-period"}>
                      {items.round_id}
                    </td>
                    <td align="center" className={"td-mines"}>
                      {items.data.detail_bet.difficulty[0]
                        .toUpperCase()
                        .concat(items.data.detail_bet.difficulty.substring(1))}
                    </td>
                    <td align="center" className={"td-totalbet"}>
                      {handleFormatCurrency(items.data.detail_bet.amount)}
                    </td>
                    <td align="center" className={"td-payout"}>
                      {handleFormatCurrency(items.data.total_win)}
                    </td>
                    <td
                      align="center"
                      className={"td-icon"}
                      onClick={() => {
                        animate.handleClose(() => {});
                        animate.open(animate.active === idx ? -1 : idx);
                      }}
                    >
                      <img
                        onContextMenu={(e) => e.preventDefault()}
                        draggable="false"
                        className=""
                        alt=""
                        src={Up}
                        style={{}}
                      />
                    </td>
                  </tr>
                  <tr
                    style={{
                      borderTop:
                        animate.active === idx
                          ? "0"
                          : "2px solid rgba(255, 255, 255, 0.1)",
                      borderBottom:
                        animate.active === idx
                          ? "2px solid rgba(255, 255, 255, 0.1)"
                          : "0",
                    }}
                  >
                    <td colSpan={6} align={"center"}>
                      <motion.div
                        initial="close"
                        animate={animate.active === idx ? "open" : "close"}
                        variants={animate.motionVariant}
                        // @ts-ignore
                        ref={animate.containerRef}
                        className="retable"
                        key={"history-table-item".concat(
                          idx.toString().concat(idx.toString())
                        )}
                      >
                        {/* History game here */}
                        <Game
                          idx={idx}
                          dataProps={{ ...items, payload: items.result }}
                        />
                      </motion.div>
                    </td>
                  </tr>
                </Fragment>
              );
            })}
            {/* </AnimatePresence> */}
          </tbody>
        </table>
      </div>
      {/* <div className="slider-y">
      <form className="rangeSlider">
        <input
          className="scroll-range"
          id="scroll-range-y"
          type="range"
          defaultValue={"0"}
        />
      </form>
    </div>
    <div className="slider-x">
      <form className="rangeSlider">
        <input
          className="scroll-range"
          id="scroll-range-x"
          type="range"
          defaultValue={"0"}
        />
      </form>
    </div> */}
      {/* @ts-ignore */}
    </motion.div>
  );
};

export default Table;
